import { cs } from 'date-fns/locale'

export default defineAppConfig({
  locale: cs,
  currency: 'CZK',
  platformName: 'epojisteni',
  blog: {
    url: '/aktuality',
    swiperName: 'Související články',
    swiperSeeAll: 'Zobrazit všechny články',
    seeAll: 'Všechny články',
    share: 'Sdílet článek',
    moreFromAutor: 'Více článků autora',
    fetchMore: 'Načíst další',
    readArticle: 'Číst článek',
    allArticles: 'Všechny články',
    mostReadArticles: 'Nejčtenější',
    topArticles: 'Top články',
    articleLength: 'Délka čtení',
    articleContent: 'Obsah článku',
    show: 'Zobrazit',
    more: 'více',
    less: 'méně',
    topics: 'témat',
    documentPatterns: 'Vzory dokumentů',
    moreInfo: 'Více informací',
    download: 'Stáhnout',
    updated: 'Aktualizováno',
    glossaryTitle: 'Slovník pojmů',
  },
})
